import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames/bind';

// Components
import Filter from 'components/Filter';
import Page from 'components/Page';
import SelectField from 'components/SelectField';

// Styles
import styles from './styles.styl';

const cx = cn.bind(styles);

function AuthorFilter({
  className,
  category,
  categories,
  changeCategory,
  sort,
  options,
  changeSort,
}) {
  const categoryOptions = useMemo(() => {
    const list = [];

    for (let i = 0; i < categories.length; i++) {
      list.push({
        label: categories[i].name,
        value: categories[i].slug,
      });
    }

    return list;
  }, [categories]);

  return (
    <Page.Section className={cx('AuthorFilter', className)}>
      <div className={cx('AuthorFilter__body')}>
        <SelectField
          className={cx('AuthorFilter__select')}
          name="category"
          value={category}
          options={[
            {
              label: 'All articles',
              value: '',
            },
            ...categoryOptions,
          ]}
          onChange={changeCategory}
          theme="inArticles"
        />
        <Filter
          className={cx('AuthorFilter__filter')}
          initialValue={sort}
          options={options}
          onChange={changeSort}
        />
      </div>
    </Page.Section>
  );
}

AuthorFilter.propTypes = {
  className: PropTypes.string,
  category: PropTypes.string,
  categories: PropTypes.array,
  changeCategory: PropTypes.func,
  sort: PropTypes.string,
  options: PropTypes.array,
  changeSort: PropTypes.func,
};

export default AuthorFilter;
